import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import Icons from "../assets/icons";
import { useLocation } from "react-router-dom";
import scrollToRef from "../utils/scrollTarget";

const affinities = [
  {
    name: "SCG Soultions",
    icon: <Icons.GroupSCGS style={{ height: "30px", width: "100%" }} />,
  },
  {
    name: "SCG Grid",
    icon: <Icons.GroupSCGGrid style={{ height: "30px", width: "100%" }} />,
  },
  {
    name: "SCG LAB",
    icon: <Icons.GroupSCGLAB style={{ height: "30px", width: "100%" }} />,
  },
  {
    name: "JUBIX",
    icon: <Icons.GroupJubix style={{ height: "30px", width: "100%" }} />,
  },
  {
    name: "SCGS Dalian",
    icon: <Icons.GroupSCGSDalian style={{ height: "30px", width: "100%" }} />,
  },
  {
    name: "SCGS Thailand",
    icon: <Icons.GroupSCGSTH style={{ height: "30px", width: "100%" }} />,
  },
];

const IntroStyle = styled.ul`
  .scroll {
    min-height: calc(var(--vh, 1vh) * 100 - 50px);
    overflow: visible;
    position: relative;
  }
`;
const KaiperMainStyle = styled.div`
  .scroll {
    min-height: 600px;
  }
  .banner-image {
    background: url("/background/kaiper-bg01.jpg");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    .banner-text {
      margin: auto;
      background: #ffffff99;
      color: #000;
      width: 100%;
      padding: 50px 0;
      text-align: center;
      h1 {
        font-size: 60px;
        line-height: 1em;
        margin: auto;
      }
    }
  }
  @media (max-width: 768px) {
    .scroll {
      min-height: 400px;
    }
    .banner-image {
      .banner-text {
        h1 {
          font-size: 30px;
        }
      }
    }
  }
`;
const KaiperMain = ({ t, i18n }: any) => {
  return (
    <KaiperMainStyle>
      <div className="banner-image scroll">
        <motion.div
          initial={{ transform: "scaleX(0)", opacity: 0 }}
          animate={{ transform: "scaleX(1)", opacity: 1 }}
          transition={{ ease: "easeOut", duration: 0.7 }}
          className="banner-text"
        >
          <motion.h1
            initial={{ translateY: "-50px", opacity: 0 }}
            animate={{ translateY: "0", opacity: 1 }}
            transition={{ delay: 0.3, ease: "easeInOut", duration: 1 }}
          >
            {t("introKaiperTitle")}
          </motion.h1>
        </motion.div>
      </div>
    </KaiperMainStyle>
  );
};

const KaiperStyle = styled.article`
  .scroll {
    display: flex;
    flex-direction: column;
    max-width: 1200px;
    margin: 100px auto;
    height: unset;
    width: 95%;
  }
  .kaiper-grid-paper {
    border: 1px solid #ddd;
    width: 100%;
    min-height: 300px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 5px auto;
  }

  .kaiper-box {
    .inner-box {
      h1 {
        font-size: 30px;
        color: #6a6e77;
        display: flex;
        border-bottom: 1px solid #6a6e77;
        margin-bottom: 10px;
        ::before {
          width: 6px;
          height: 22px;
          margin: auto 7px auto 0;
          background-color: #6a6e77;
        }
      }
      .kaiper-description {
        text-align: left;
        margin-bottom: 50px;
        word-break: keep-all;
        p {
          margin-bottom: 10px;
        }
      }
      .kaiper-article {
        position: relative;
        margin-bottom: 100px;
        .kaiper-article-title {
          width: 100%;
          h2 {
            min-width: 150px;
            background: #6a6e77;
            color: #fff;
            min-height: 50px;
            display: flex;
            span {
              margin: auto;
            }
          }
        }
        .kaiper-article-group-box {
          background-color: #eee;
          padding: 50px;
          display: flex;
          justify-content: center;
          align-items: center;
          .kaiper-group {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
            .group-li {
              padding: 15px 33px;
              display: flex;
              .group-p {
                font-size: 30px;
                color: #000;
                font-weight: bold;
                text-align: center;
                letter-spacing: -1px;
                display: flex;
              }
            }
          }
        }
        .kaiper-article-grid-box {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          &.slogan-box {
            .kaiper-grid-paper {
              .logo-box {
                aspect-ratio: unset;
              }
            }
          }
        }
        .kaiper-article-color-box {
          color: #fff;
          .kaiper-color {
            .kaiper-color-item {
              padding: 10px 20px;
              transition: 0.1s;
              box-shadow: 0px 0px 0px 0px #000000;
              :hover {
                transition: 0.3s;
                transform: translate(3px, -3px);
                box-shadow: -3px 3px 5px 0px #00000033;
              }
              p {
                b {
                  display: block;
                  margin-bottom: 5px;
                }
              }
              &.gray {
                background-color: #6a6e77;
              }
              &.black {
                background-color: #000000;
              }
              .kaiper-code-ul {
                display: flex;
                .kaiper-code-li {
                  margin-right: 10px;
                }
              }
            }
          }
        }
        .logo-box {
          display: flex;
          flex-direction: column;
          /* justify-content: center; */
          /* align-items: center; */
          aspect-ratio: 4 / 1;
          width: 90%;
          max-width: 800px;
          margin: 20px auto;
        }
      }
    }
  }
  h1 {
    width: 100%;
    border-bottom: 2px solid #6a6e77;
  }
  @media (max-width: 768px) {
    .kaiper-box {
      .inner-box {
        .kaiper-article {
          .kaiper-article-grid-box {
            &.slogan-box {
              .kaiper-grid-paper {
                min-height: 300px;
                .logo-box {
                  margin: unset;
                }
              }
            }
            flex-direction: column;
            .kaiper-grid-paper {
              width: 100%;
              margin: 0 auto 50px;
            }
            .logo-box {
              width: 90%;
              margin: 50px auto;
            }
          }
          .kaiper-article-group-box {
            padding: unset;
            .kaiper-group {
              flex-direction: column;
              .group-li {
                padding: 20px 0;
                .group-p {
                }
              }
            }
          }
        }
      }
    }
  }
  @media (max-width: 480px) {
    .kaiper-box {
      .inner-box {
        .kaiper-article {
          .kaiper-article-grid-box {
            .kaiper-grid-paper {
              min-height: unset;
              margin: 0 auto 20px;
            }
            .logo-box {
              width: 95%;
              margin: 10% auto;
            }
          }
        }
      }
    }
  }
`;

const Kaiper = ({ t, i18n }: any) => {
  return (
    <KaiperStyle>
      <div className="scroll">
        <div className="kaiper-box">
          <div className="inner-box">
            <section className="kaiper-article">
              <article className="kaiper-article-title">
                <h1>
                  <p>{t("kaiperGroup")}</p>
                </h1>
              </article>

              <div className="kaiper-description">
                <p>{t("kaiperDescription_1_1_1")}</p>
                <p>{t("kaiperDescription_1_1_2")}</p>
              </div>
              <article className="kaiper-article-group-box">
                <ul className="kaiper-group">
                  {affinities.map((affinity) => (
                    <li key={affinity.name} className="group-li">
                      <p className="group-p">{affinity.icon}</p>
                    </li>
                  ))}
                </ul>
              </article>
            </section>

            <section className="kaiper-article">
              <article className="kaiper-article-title">
                <h1>
                  <p>{t("kaiperSignature")}</p>
                </h1>
              </article>
              <article className="kaiper-article-grid-box">
                <div className="kaiper-grid-paper">
                  <div className="logo-box">
                    <Icons.LogoKaiperDefault />
                  </div>
                </div>
              </article>
              <div className="kaiper-description">
                <p>{t("kaiperDescription_2_1_1")}</p>
              </div>
            </section>

            <section className="kaiper-article">
              <article className="kaiper-article-title">
                <h1>
                  <p>{t("kaiperSlogan")}</p>
                </h1>
              </article>
              <article className="kaiper-article-grid-box slogan-box">
                <div className="kaiper-grid-paper">
                  <div className="logo-box">
                    <Icons.SloganKaiperdefault />
                  </div>
                  {/* <div className="logo-box">
                    <Icons.SloganKaiperClearspace />
                  </div> */}
                </div>
              </article>
              <div className="kaiper-description">
                <p>{t("kaiperDescription_3_1_1")}</p>
                <p>{t("kaiperDescription_3_1_2")}</p>
              </div>
            </section>
          </div>
        </div>
      </div>
    </KaiperStyle>
  );
};

const IntroKaiper = ({ t, i18n }: any) => {
  const location = useLocation();
  const up1 = useRef(null);
  const options = {
    root: null,
    rootMargin: "-10%",
    threshold: 0,
  };
  useEffect(() => {
    switch (location.state) {
      case 0:
        scrollToRef(up1, location);
        break;
      default:
        break;
    }
  }, [location.state]);

  useEffect(() => {
    const observer = new IntersectionObserver((e) => {
      e.map((f) => {
        return f.isIntersecting && f.target.classList.add("up");
      });
    }, options);
    up1.current && observer.observe(up1.current);
  });
  return (
    <IntroStyle className="no-select">
      <KaiperMain t={t} i18n={i18n} />
      <section className="up-soon" ref={up1}>
        <Kaiper t={t} i18n={i18n} />
      </section>
    </IntroStyle>
  );
};

export default IntroKaiper;
